import AnimTextMarker from './AnimTextMarker';
import inview from 'jquery-inview';
import {TweenMax, TimelineLite} from "gsap";

module.exports = function(str) {
	// const text_marker = new AnimTextMarker('.js-textmarker');
	// text_marker.mark();
	// text_marker.draw();

	// $('.home_our_value .text_animation-bounds').on('inview',function(event, isInView, visiblePartX, visiblePartY){
	// 	if(!$(this).hasClass('animated')){
	// 		$(this).addClass('active');
	// 	}
	// });

	const TL1 = new TimelineMax();
	const TL2 = new TimelineMax();
	const TL3 = new TimelineMax();
	const TL4 = new TimelineMax();


	$('.home_our_value .textarea').on('inview',function(event, isInView, visiblePartX, visiblePartY){
		TL1

		.to('.js-animate_017', .6, {autoAlpha: 1 ,top:0, delay : 0 })
		.to('.js-animate_018', .6, {autoAlpha: 1 ,top:0})
		.to('.js-animate_019', .6, {autoAlpha: 1 ,top:0})
		.to('.js-animate_016', .6, {autoAlpha: 1})
	});

	$('.home_works').on('inview',function(event, isInView, visiblePartX, visiblePartY){
		TL2
		.to('.js-animate_004', .6, {autoAlpha: 1})
		.to('.js-animate_005', .6, {
				autoAlpha: 1,
				onComplete:function(){
					$('.js-animate_005').find('.text_animation-bounds').addClass('active');
				}
		})
		.to('.js-animate_006', .6, {autoAlpha: 1});
	});


	$('.home_news').on('inview',function(event, isInView, visiblePartX, visiblePartY){
		TL3
		.to('.js-animate_013', .6, {
				autoAlpha: 1,
				onComplete:function(){
					$('.js-animate_013').find('.text_animation-bounds').addClass('active');
				}
		});
	});

	$('.home_about').on('inview',function(event, isInView, visiblePartX, visiblePartY){
		TL4
		.to('.js-animate_014', .6, {autoAlpha: 1})
		.to('.js-animate_015', .6, {
				autoAlpha: 1,
				onComplete:function(){
					$('.js-animate_015').find('.text_animation-bounds').addClass('active');
				}
		})
	});
}



// WEBPACK FOOTER //
// ./dev/js/scripts/text_animation.js